export class HtmlPolicy {
    public title: any;
    public body: any;
}